export const GET_CAMPAIGNS = "campaigns/get";
export const GET_SORTED_CAMPAIGNS = "campaigns/getSorted";
export const GET_CAMPAIGNS_BY_NAME = "campaigns/getByName";
export const GET_CAMPAIGNS_PARAMS = "campaigns/getParams";
